import { Flex, Stack, Text } from "@mantine/core";
import { BarChart, LineChart } from "@mantine/charts";
import React, { useEffect } from "react";
import * as ss from "simple-statistics";
import { useTranslation } from "react-i18next";

export default function NewVfiChart(props) {
  const [data, setData] = React.useState([]);
  const [barData, setBarData] = React.useState([]);
  const [slope, setSlope] = React.useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    if (props.data) {
      setData(props.data);

      const regressionData = props.data.map((d) => [d.age, d.vfi]);
      const regression = ss.linearRegression(regressionData);
      const regressionLine = ss.linearRegressionLine(regression);

      const maxAge = Math.max(...props.data.map((d) => d.age));
      const minAge = Math.min(...props.data.map((d) => d.age));

      const slope = regression.m;
      setSlope(slope);

      const temp = [];
      props.data.forEach((d, index) => {
        temp.push({ age: d.age, vfi: d.vfi.toFixed(2) });
        if (index !== props.data.length - 1) {
          temp.push({ age: d.age, vfi: null });
        }
      });

      const futurePrediction = Math.max(0, regressionLine(maxAge + 5));
      const currentPrediction = regressionLine(maxAge);

      temp.push({ age: maxAge, current: currentPrediction.toFixed(2) });
      temp.push({ age: maxAge + 10, current: currentPrediction.toFixed(2) });

      temp.push({ age: maxAge, currentVertical: currentPrediction.toFixed(2) });
      temp.push({ age: maxAge, currentVertical: 0 });

      temp.push({ age: minAge, regression: regressionLine(minAge).toFixed(2) });
      temp.push({ age: maxAge, regression: currentPrediction.toFixed(2) });

      if (futurePrediction > 0 && futurePrediction < 100) {
        temp.push({ age: maxAge + 5, regression: futurePrediction.toFixed(2) });

        temp.push({ age: maxAge + 5, future: futurePrediction.toFixed(2) });
        temp.push({ age: maxAge + 10, future: futurePrediction.toFixed(2) });

        temp.push({ age: maxAge + 5, currentVertical: futurePrediction.toFixed(2) });
        temp.push({ age: maxAge + 5, currentVertical: 0 });

        const current = regressionLine(maxAge);
        const future = regressionLine(maxAge + 5);
        setBarData([
          {
            vfi: "Regression",
            Current: current.toFixed(2),
            Future: (future - current).toFixed(2),
          },
        ]);
      } else if (futurePrediction >= 100) {
        const hundredAge = ((100 - regression.b) / regression.m).toFixed(2);
        temp.push({ age: hundredAge, regression: 100 });
        temp.push({ age: hundredAge, future: 100 });
        temp.push({ age: hundredAge + 10, future: 100 });

        const current = regressionLine(maxAge);
        setBarData([
          {
            vfi: "Regression",
            Current: current.toFixed(2),
            Future: (100 - current).toFixed(2),
          },
        ]);
      } else {
        const zeroAge = -regression.b / regression.m;
        temp.push({ age: zeroAge.toFixed(2), regression: 0 });
        setBarData([
          {
            vfi: "Regression",
            Current: regressionLine(maxAge).toFixed(2),
          },
        ]);
      }
      console.log("data", temp);
      setData(temp);
    }
  }, [props]);

  return (
    data.length > 0 && (
      <Stack>
        <Flex my={"md"}>
          <LineChart
            h={300}
            data={data}
            dataKey="age"
            series={[
              { name: "currentVertical", color: "gray", strokeDasharray: "5 5" },
              { name: "current", color: "gray", strokeDasharray: "5 5" },
              { name: "future", color: "gray", strokeDasharray: "5 5" },
              { name: "regression", color: "red" },
              { name: "vfi", color: "indigo.6" },
            ]}
            xAxisProps={{
              type: "number",
              domain: [data[0].age, data[data.length - 1].age],
            }}
            yAxisProps={{ type: "number", domain: [0, 120] }}
            xAxisLabel="Age"
            yAxisLabel="VFI"
            curveType="linear"
            connectNulls={false}
          />
          <BarChart
            px={"md"}
            w={"20%"}
            h={300}
            data={barData}
            dataKey="Regression"
            type="stacked"
            withTooltip={false}
            series={[
              { name: "Current", color: "blue.6" },
              { name: "Future", color: "violet.6" },
              { name: "Max", color: "gray" },
            ]}
            yAxisProps={{ type: "number", domain: [0, 120] }}
            tickLine="x"
            xAxisLabel=" "
            withXAxis={true}
            withYAxis={false}
          />
        </Flex>
        <Text fw={500}>
          {t("newVfiChart.rateOfProgression") + ": " + slope.toFixed(2) + " ± 1.0% (95%)"}
        </Text>
      </Stack>
    )
  );
}
